//
// 参照番号（ロール品: 契約番号 / スポット品: 購買オーダ番号）の正規化。
// ミルシートの「注文番号」と発注データの参照番号は、この正規化を通した値同士の
// 完全一致で紐付ける（検索時にだけ正規化する方式は取らない。
// docs/domain/order_matching/04_matching_logic.md）。
// 紐付けの成否に直結するため、仕様変更時は必ずテーブル駆動テストを更新すること。
//

// 全角英数記号（U+FF01〜U+FF5E）は、対応する半角文字と 0xFEE0 差で並んでいる
const FULL_WIDTH_ASCII_REGEXP = /[！-～]/g

export function normalizeReferenceNumber(value: string): string {
  return value
    .replace(FULL_WIDTH_ASCII_REGEXP, (char) => String.fromCharCode(char.charCodeAt(0) - 0xfee0))
    .replace(/\u3000/g, ' ') // 全角スペースは trim で除去できるよう半角へ寄せる
    .trim()
    .toUpperCase()
}
